import OptionButton from "@components/quiz/OptionButton"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { QuizOption } from "../quizSteps"
import StepHeading from "./StepHeading"

const AUTO_ADVANCE_DELAY_MS = 350

interface Props {
  id: string
  onAnswer: (answers: string[]) => void
  options: QuizOption[]
}

export default function SingleSelectStep({ id, onAnswer, options }: Props) {
  const [selected, setSelected] = useState<string>()
  const { t } = useTranslation()

  const handleSelect = (optionId: string) => {
    if (selected) return

    setSelected(optionId)
    setTimeout(() => onAnswer([optionId]), AUTO_ADVANCE_DELAY_MS)
  }

  return (
    <div className="flex grow flex-col gap-6 pt-4">
      <StepHeading
        headingKey={`pages.onboarding.steps.${id}.heading`}
        subheadingKey={`pages.onboarding.steps.${id}.subheading`}
      />

      <div className="mt-auto flex flex-col gap-2.5 pb-6">
        {options.map((option, index) => (
          <OptionButton
            animationDelayMs={120 + index * 60}
            emoji={option.emoji}
            indicator="none"
            isSelected={selected === option.id}
            key={option.id}
            label={t(`pages.onboarding.steps.${id}.options.${option.id}`)}
            onClick={() => handleSelect(option.id)}
          />
        ))}
      </div>
    </div>
  )
}
